/**
 * /servere-dedicate — migrated from public/js/dedicated.js.
 *
 * 1. .layer-1 .col i Tooltip
 * 2. Focus/blur input/textarea .lb-focused
 * 3. Switch sums cu logica specifica: copiaza state pe .package:not(.visible)
 *    INSTANT, dar animeaza fade pe .package.visible (current state).
 * 4. .show-more click — slideDown .row-more apoi mark .package.visible
 * 5. #request-form — Form() pentru server request (no-op via shim)
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    ($('.layer-1 .col i', true) as NodeListOf<Element>).Tooltip();

    $('input[type="text"], textarea', true).on('focus', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
    });
    $('input[type="text"], textarea', true).on('blur', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
    });

    let switchReady = true;
    ($('header .switch-btn', true) as NodeListOf<Element>).on('click', 'a', function (this: Element) {
        if (!switchReady) return;
        switchReady = false;
        if (this.classList.contains('active')) {
            switchReady = true;
            return;
        }
        ($('header .switch-btn a.active') as Element | null)?.classList.remove('active');
        this.classList.add('active');

        const targetId = (this as HTMLElement).dataset['id'];

        /* Pe .package:not(.visible) doar swap clase, fara animatie */
        ($('.layer-1 .package:not(.visible)') as Element | null)?.find('.sum.active')?.classList.remove('active');
        ($('.layer-1 .package:not(.visible)') as Element | null)?.find(`.sum[data-id="${targetId}"]`)?.classList.add('active');

        /* Pe .package.visible — animatii fade */
        $('.layer-1 .package.visible .sum.active', (active: Element) => {
            active.classList.add('fade-out-fast');
            active.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('active', 'fade-out-fast');
                switchReady = true;
            }, { once: true });
            return true;
        });
        $(`.layer-1 .package.visible .sum[data-id="${targetId}"]`, (layer: Element) => {
            layer.classList.add('active', 'fade-in-fast');
            layer.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('fade-in-fast');
                switchReady = true;
            }, { once: true });
            return true;
        });
    });

    /* Show more plans */
    ($('.layer-1') as Element | null)?.on('click', 'a.show-more', function (this: Element) {
        const tools = this.parents('.tools') as HTMLElement | null;
        if (!tools) return;
        tools.style.display = 'none';
        (tools.prev('.row-more') as HTMLElement | null)?.slideDown(function (this: HTMLElement) {
            (this.find('.package') as Element | null)?.classList.add('visible');
        });
    });

    /* Server request form — submit nativ catre /message/send (shim) */
    const is_en = /\/en\//.test(window.location.href);
    const rForm = $('#request-form') as HTMLFormElement | null;
    if (rForm) {
        rForm.Form('form', 'server_send_request', {}, {
            valid: () => ({
                company: 'min(5)max(40)',
                name:    'min(5)max(40)',
                email:   'mail(40)',
                phone:   'min(10)max(30)',
                message: 'nn()max(10000)',
            }),
            done: (r: unknown) => {
                if (r === 'Done') {
                    // Legacy: Notify() global — folosim window.rt.notify
                    window.rt && (window.rt as { notify: (m: string) => void }).notify(
                        is_en ? 'Your request was sent successfully.' : 'Cererea ta a fost expediată cu succes.',
                    );
                    rForm.reset();
                }
            },
        });
    }
});
